import axios from "axios";
import OrderFormStep from "../common/OrderFormStep";
import Config from "../common/Config";
import FieldState from "../common/FieldState";
import LoadFailureResult from "../common/LoadFailureResult";
import InputTextField from "../components/textField/InputTextField";
import PhoneNumber from "../components/phoneNumber/PhoneNumber";
import MuiRadio from "../components/radio/MuiRadio";
import FormTitle from "../components/formTitle/FormTitle";
import "./forms.scss";
import Button from "../components/button/Button";
import SecondaryButton from "../components/button/SecondaryButton";
import { CreateNotification } from "../components/notification/Notification";
import SaveAsDraft from "../components/modal/SaveAsDraft";
import ClearOrder from "../components/modal/ClearOrder";

import MuiCheckbox from "../components/checkbox/MuiCheckbox";
import RangeSlider from "../components/range/RangeSlider";

export default class XTremityPreQualification extends OrderFormStep {
  constructor(props) {
    super(props);

    this.state = {
      accountNumber: localStorage.getItem("accountNumber"),
      MinLength: 7,
      MaxLength: 27,
      isLoading: false,
      insertMaterials: [],
      formState: {
        insertMaterial: new FieldState(false, {}),
        DistalCircumference: new FieldState(true),
        Length: new FieldState(true),
        MPTCircumference: new FieldState(true),
      },
    };

    this.handleSliderChange = this.handleSliderChange.bind(this);
  }

  handleSliderChange(name, value) {
    let formState = this.state.formState;
    formState[name].value = value;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    this.setState({
      insertMaterials: (
        await axios.get(
          Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
          { params: { fieldName: "insertMaterial" } }
        )
      ).data
    })

    let formState = this.state.formState;

    let config = {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
      },
      params: {
        fieldNames: [
          "insertMaterial",
          "MPTCirc",
          "distalCirc",
          "limbLength"
        ],
      },
    };

    const { data } = await axios.get(
      Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
      config
    );

    if(data) {
      formState.Length.value = data.find(
        (fi) => fi.fieldName === "limbLength"
      ).numericData;
      formState.MPTCircumference.value = data.find(
        (fi) => fi.fieldName === "MPTCirc"
      ).numericData;
      formState.DistalCircumference.value = data.find(
        (fi) => fi.fieldName === "distalCirc"
      ).numericData;
  
      for (let i = 0; i < this.state.insertMaterials.length; i++) {
        let fieldOptionId = this.state.insertMaterials[i].id;
        let fieldInput = data.find(
          (fi) =>
            fi.fieldName === "insertMaterial" &&
            fi.fieldOptionId === fieldOptionId
        );
  
        if (fieldInput !== undefined && fieldInput.booleanData !== null) {
          formState.insertMaterial.value[fieldOptionId] =
            fieldInput.booleanData;
        } else {
          formState.insertMaterial.value[fieldOptionId] = false;
        }
      }
    }

    this.setState({ 
      formState: formState, 
      isLoaded: true
    });
  }

  saveData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let fieldInputData = [];

    fieldInputData.push({
      fieldName: "limbLength",
      numericData: this.state.formState.Length.value,
    });
    fieldInputData.push({
      fieldName: "MPTCirc",
      numericData: this.state.formState.MPTCircumference.value,
    });
    fieldInputData.push({
      fieldName: "distalCirc",
      numericData: this.state.formState.DistalCircumference.value,
    });

    var hasInsert = false;
    for (let i = 0; i < this.state.insertMaterials.length; i++) {
      let fieldOptionId = this.state.insertMaterials[i].id;

      fieldInputData.push({
        fieldName: "insertMaterial",
        fieldOptionId: fieldOptionId,
        booleanData: this.state.formState.insertMaterial.value[fieldOptionId],
      });
      
      hasInsert = hasInsert || this.state.formState.insertMaterial.value[fieldOptionId];
    }


    this.validateMeasurements(hasInsert).then(response => {
      if (!response.data.success) {
        console.log(response.data);
        this.setState({ isLoading: false });
        CreateNotification("Sorry, but we are unable to offer an Xtremity Limb in this size.", "error");
      } else if (this.validateData().isValid) {
        axios.post(
          Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
          fieldInputData,
          config
        )
          .then(res =>{
            if (res.status === 200 || res.status === 204) {
              this.props.handleNext(this?.props?.currentIndex);
              this.setState({ isLoading: false });
              CreateNotification("Submitted", "success");
            }
          })
          .catch((error) => {
            console.log(error);
            this.setState({ isLoading: false });
          });
      } else {
        this.setState({
          isSubmit: true,
        });
        CreateNotification(this.validateData().errorMessage, "error");
        this.setState({ isLoading: false });
      }
    })
    .catch((error) => {
      console.log(error);
      this.setState({ isLoading: false });
    });
  }

  validateMeasurements(hasInsert) {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    return axios.post(
      Config.baseApiUrl + "XtremitySizeValidation/",
      {
        HasLiner: hasInsert,
        Length: this.state.formState.Length.value,
        DistalCircumference: this.state.formState.DistalCircumference.value,
        MPTCircumference: this.state.formState.MPTCircumference.value
      },
      config
    );
  }


  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  onPhoneChange(value) {
    this.setState({ number: value });
    if (value === undefined) {
      this.state.formState.phone.value = "";
    } else {
      this.state.formState.phone.value = value;
    }
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    return (
      <>
        <div className="checkFormWrapper">
          <FormTitle
            title="Size Validation"
            description=""
          />

          <form className="checkform" onSubmit={e => {e.preventDefault()}}>
            <div className="fieldWrapper filedWidth fieldBorder">
                <MuiCheckbox
                  checkboxes={this.state.insertMaterials}
                  boxLabel="Insert Material"
                  defaultValue={this.state.formState.insertMaterial.value}
                  error={
                    this.handleError("insertMaterial") && this.state.isSubmit
                  }
                  onChange={(e, id) => {
                    this.onCheckboxChange(e, id, "insertMaterial");
                  }}
                />
              </div>
              <div className="fieldBorder">
                <h4 className="headLable">Measurements</h4>
                <div className="fieldWrapper">
                <InputTextField
                    label="Length (cm)"
                    placeholder="10"
                    type="number"
                    error={
                      this.handleError("Length") && this.state.isSubmit
                    }
                    required={this.state.formState["Length"].isRequired}
                    margin={true}
                    value={this.state.formState.Length.value}
                    onChange={(e) => {
                      this.onInputChange(e, "Length");
                    }}
                  />

                  <InputTextField
                    label="Distal Circumference (cm)"
                    placeholder="30.0"
                    type="number"
                    error={
                      this.handleError("DistalCircumference") && this.state.isSubmit
                    }
                    required={this.state.formState["DistalCircumference"].isRequired}
                    margin={true}
                    value={this.state.formState.DistalCircumference.value}
                    onChange={(e) => {
                      this.onInputChange(e, "DistalCircumference");
                    }}
                  />

                  <InputTextField
                    label="MPT Circumference (cm)"
                    placeholder="30.0"
                    type="number"
                    error={
                      this.handleError("MPTCircumference") && this.state.isSubmit
                    }
                    required={this.state.formState["MPTCircumference"].isRequired}
                    margin={true}
                    value={this.state.formState.MPTCircumference.value}
                    onChange={(e) => {
                      this.onInputChange(e, "MPTCircumference");
                    }}
                  />
                </div>
              </div>
              <div className="msgBox fieldBorder msgBoxWidth">
	              <h4 className="headLable"><b>Indications</b></h4>
                  <ul>
        	          <li>Unilateral or bilateral transtibial amputations</li>
                    <li>275 lbs or less</li>
                    <li>Distal limb circumference between 26-38 cm</li>
                    <li>Socket Length less than 29cm (from most proximal edge to distal end of limb)</li>	
	                </ul>
	              <h4 className="headLable"><b>Contraindications</b></h4>
                <ul>
        	        <li>Bulbous or irregular shaped limbs</li>
                  <li>Atypical alignment of the socket & foot</li>
                  <li>Measurements outside of the sizing chart</li>
                  <li>Long residual limbs/Symes/Transfemoral</li>
                  <li>High Activity Patients over 220lb</li>
                  <li>Trim lines that fall outside Guidelines:
			              <ul>
                	    <li>2.5cm proximal to MPT</li>
                      <li>Popilteal shelf greater than 6mm distal to MPT</li>
                      <li>Sharp radii in the hamstring area</li>
                	  </ul>
                  </li>
	              </ul>
              </div>
          </form>
        </div>

        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <SecondaryButton
            text = "Clear the Order?"
            onClick = {this.props.handleClickClearOpen}
          />  
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={() => {
                this.props.handleBack(this.props.currentIndex - 1);
                if (this.props.setIsBack) this.props.setIsBack(true);
              }}
              disabled={this.props.disableBackButton}
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                try {
                  this.setState({ isLoading: true });
                  const res = await this.saveData();
                  if (res.status === 204) {
                    this.props.handleNext(this.props.currentIndex);
                    this.setState({ isLoading: false });
                    CreateNotification("Submitted", "success");
                  }
                } catch (err) {
                  this.setState({ isLoading: false });
                }
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        <ClearOrder
          openClear={this.props.openClear}
          handleCloseClear={this.props.handleCloseClear}
          showClear={this.props.showClear}
          setShowClear={this.props.setShowClear}
          formId = {this.props.formTypeId}
          handleClearBack={this.props.handleClearBack}
        />          
      </>
    );
  }
}
